/* eslint-disable react/prop-types */

import { createContext } from 'react';
import { UseChatHelpTimer } from './useChatTimer';
import { UseOnRouteChange } from '../../hooks/useOnRouteChange';


export const ChatTimerContext = createContext();

export const ChatTimerProvider = ({ children }) => {
  const {
    clearTimer,
    initChatHelper,
    restartTimer,
    setShouldRenderChat,
    shouldRenderChat,
    timer,
    setTime
  } = UseChatHelpTimer()

  UseOnRouteChange(()=>clearTimer())

  return (
    <ChatTimerContext.Provider value={{
      clearTimer,
      initChatHelper,
      restartTimer,
      setShouldRenderChat,
      setTime,
      shouldRenderChat,
      timer,
    }}>
      {children}
    </ChatTimerContext.Provider>
  );
}
